import { render, staticRenderFns } from "./lawoffLocfir.vue?vue&type=template&id=62129e0c&scoped=true&"
import script from "./lawoffLocfir.vue?vue&type=script&lang=js&"
export * from "./lawoffLocfir.vue?vue&type=script&lang=js&"
import style0 from "./lawoffLocfir.vue?vue&type=style&index=0&id=62129e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62129e0c",
  null
  
)

export default component.exports